export default __webpack_public_path__ + "static/media/gb_minor.ce3d57cd.jpg";